import { render, staticRenderFns } from "./register-has-issues.vue?vue&type=template&id=da2d4b00&lang=pug&"
import script from "./register-has-issues.vue?vue&type=script&lang=ts&"
export * from "./register-has-issues.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports